import React, { useEffect, useState } from 'react'
import ModalCustom from '../../modal-custom'
import { Col, Row } from 'react-bootstrap'
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa'
import { getChecklistResignDetailAPI } from '../../../services/checklist'
import Error_false from '../../error/error-false'

function ModalManager({ modelManager, hadleCloseManager, data }) {
  const [dataManager, setDataManager] = useState(false)
  const [isSave, setIsSave] = useState(false)

  useEffect(() => {
    const fnGetDetail = async () => {
      const body = { clrNo: data?.clr_no }
      setIsSave(true)
      const resp = await getChecklistResignDetailAPI(body)
      if (!resp) return
      if (resp.status) {
        setDataManager(resp.result)
        setIsSave(false)
      } else {
        Error_false(resp)
      }
    }
    if (modelManager) {
      fnGetDetail()
    }
  }, [modelManager])

  return (
    <ModalCustom open={modelManager} onCancel={hadleCloseManager}>
      {isSave && <div className="preloader"></div>}

      <h5 className="">Manager Approved</h5>
      <Row className="mt-3">
        <Col xl={12}>
          <div>Status</div>

          <p className="fw-light">
            {dataManager?.is_approve === 1 ? (
              <p className="text-success">
                {' '}
                Approved <FaCheckCircle className="text-success" />
              </p>
            ) : dataManager?.is_approve === 0 ? (
              <>
                <p className="text-danger">
                  {' '}
                  Reject <FaTimesCircle className="text-danger" />
                </p>
              </>
            ) : (
              <p className="">
                {" "}-
              </p>
            )}
          </p>
        </Col>

        <Col xl={6}>
         
         
            {dataManager?.is_approve === 1 ? (
              <></>
            ) : dataManager?.is_approve === 0 ? (
              <>
               <div> Reason</div>
                <p> {dataManager.approve_description}</p>
              </>
            ) : (
              <></>
            )}
         
        </Col>
      </Row>
    </ModalCustom>
  )
}

export default ModalManager
